export const update_user_language = `mutation update_user_language($input: String!){
    update_user_language(input: $input)
}`;
